// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__BmFbw","footer":"ModalCreateQualiphyProcedure_footer__1kV4T","additionData":"ModalCreateQualiphyProcedure_additionData__FsMoy"};